module.exports = __webpack_public_path__ + "img/htkj_13.e40edd49.jpg";